import React, { useEffect, useState,useRef } from 'react'
import { DeleteForeverOutlined, Home, HighlightOff } from '@mui/icons-material';
import toast from 'react-hot-toast';
import axios from 'axios';
import { Url } from '../services/Constants';
import { useNavigate } from 'react-router-dom';
import { setHeader } from '../services/Headers';




export default function AddressTile({data}) {



  const Navigate = useNavigate()
  const [address,setAddress] = useState(data.item.street_address)
  const [pincode, setPincode] = useState(data.item.pincode)
  const [state, setState] = useState()
  const [city,setcity] = useState()
  const [isEdit, setIsedit] = useState(false)
  const [pincodeData,setPincodeData] = useState()


 useEffect(()=>{
          if(pincodeData){
          setState(pincodeData.State)
          setcity(pincodeData.District)
          }

 },[pincodeData])
 


 const disableHande =()=>{
  toast.error("Please Enter Pincode!")
}


const pincodeFinder = async(e)=>{
  let numlength = e.target.value.toString()
  if(numlength.length === 6){
  if(e.target.value){
      try {
          const data= e.target.value
          const result = await axios.get(`https://api.postalpincode.in/pincode/${data}`)
          if(result.data[0].Status === "Success"){
          setPincodeData(result.data[0].PostOffice[0])
          setPincode(e.target.value)
          }else{
              setPincodeData(null)
              toast.error("Please Enter Correct Pincode")
          }
      } catch (error) {
          console.log(error)
      }
  }
  else{
    setPincodeData(null)
  }
  }
}



  
const updateAddress = async()=>{
  const id = data.item.id
  if(!address){
      toast.error("Please Enter Address!")

  }else{
      const data ={
          street_address:address,
          city:city,
          state:state,
          pincode:pincode
      }
      try {
          
          const result = await axios.put(`${Url}/buyer/addresses/${id}`,data,setHeader())
          if(result.data.response_code==200){
              toast.success("Address added Successfully.")
              relode()
              setIsedit(!isEdit)
          }
          else{
              toast.error("Somthing Went Wrong!")
          }
      } catch (error) {
          console.log(error)
      }

  }
}

function relode(){
  data.relodeHandle()
}

const addressChange =(e)=>{
setAddress(e.target.value)
}


const EditAddressForm = (items)=>{
  return(
 <div className=" add-address-container w-full h-screen bg-opacity-75 bg-black flex justify-center left-0 items-center fixed top-0 z-50">
        <div className="address-modal w-96 bg-gray-300 rounded-2xl shadow-2xl z-40 max-sm:w-[90%]">
          <div className="address-modal-top w-full mx-auto flex flex-col items-center">
            <div className="title mt-1 border-b border-b-amber-950 w-[95%] text-center">
                <div className="close text-end  ">
                <HighlightOff sx={{ fontSize: 28 }} className="hover:bg-red-700 hover:text-white cursor-pointer  rounded-full m-0 p-0" onClick={()=>setIsedit(!isEdit)}/>
                </div>
                <span className='text-amber-950 font-bold text-2xl'>Add Address</span>
            </div>
            <div className="disabled w-full flex justify-center" onClick={disableHande}>
            <input type="text" defaultValue={data.item.state} value={state} name="" id="" className='outline-none rounded-xl mx-auto w-[90%] my-3 py-2 px-1 text-amber-950 bg-slate-100' placeholder='State' disabled/>
            </div>
            <div className="disabled w-full flex justify-center" onClick={disableHande}>
            <input type="text" defaultValue={data.item.city} value={city} name="" id="" className='outline-none rounded-xl w-[90%] my-3 py-2 px-1 text-amber-950 bg-slate-100' placeholder='City' disabled />
            </div>
            <input type="text" name="" id="" className='outline-none rounded-xl w-[90%] my-3 py-2 px-1 text-amber-950' defaultValue={pincode} placeholder='Pincode' onChange={pincodeFinder} maxLength={6}/>
            <input type="text" name="" id="" className='outline-none rounded-xl w-[90%] my-3 py-2 px-1 text-amber-950 resize-none' defaultValue={address} onBlur={addressChange} placeholder='Address'/>
            <button className='block bg-amber-950 text-white px-5 py-1 rounded-lg mb-4 cursor-pointer' onClick={updateAddress}>Update Address</button>
          
          </div>
          <div className="address-modal-bottom flex flex-col justify-center items-center">                          
          </div>
        </div>
      </div>
  )}



  return (
  <>
    <div key={data.item.id} className="address bg-white p-4 h-full shadow-2xl rounded-2xl mb-4 flex flex-col md:flex-row relative z-40">
           <div className="top mx-[2%] w-full md:w-[95%]">
            <div className="user-name w-[90%] text-amber-950 text-2xl font-bold flex justify-between cursor-default">
                <div className="left flex items-center w-1/2">
                  <span className="address-type-name">{data.profile.name}</span>
                  {/* <div className="address-type ml-[2%] flex items-center justify-center border w-[70%] md:w-[16%] h-[30%] md:h-[50%] rounded-2xl border-amber-950">
                      <Home sx={{fontSize:15}}/>
                      <span className="address-type-name text-xs md:text-[60%]">Home</span>
                  </div> */}
                </div>
                {/* <DeleteForeverOutlined fontSize='large' className="relative left-[14%] p-[1%] cursor-pointer rounded-full hover:text-white hover:bg-red-600"/>  */}
            </div>
            <div className="bottom">
                <span className="address text-amber-950">{`${data.item.street_address}, ${data.item.city}, ${data.item.state} - ${data.item.pincode}`}</span>
                <div className="button bg-amber-950 rounded-md mt-[2%] py-[0.5%] cursor-pointer w-[30%] md:w-[10%] text-center text-white hover:bg-amber-900" onClick={()=>setIsedit(!isEdit)}>Edit</div>
            </div>
          </div>
    </div>

    {isEdit?<EditAddressForm/>:""}
    
    </>
  )
}  
